import React from "react";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";

import type { ValidNewsletterPackageKey } from "shared/data/newsletter";
import { notEmpty } from "shared/lib/utils";

import { ThumbnailContainer } from "./styles";
import analysisAndOpinion from "./thumbnail-assets/desktop/analysis-and-opinion.gif";
import biztechAndEconomy from "./thumbnail-assets/desktop/biztech-and-economy.gif";
import chinaAndAsiaUnpacked from "./thumbnail-assets/desktop/china-and-asia-unpacked.gif";
import essential from "./thumbnail-assets/desktop/essential.gif";
import everythingInHongKong from "./thumbnail-assets/desktop/everything-in-hong-kong.gif";
import lifestyle from "./thumbnail-assets/desktop/lifestyle.gif";
import picturesFilmsAndVideo from "./thumbnail-assets/desktop/pictures-films-and-video.png";
import sport from "./thumbnail-assets/desktop/sport.png";

const thumbnailMap: Record<ValidNewsletterPackageKey, StaticImageData> = {
  "Analysis & Opinion": analysisAndOpinion,
  "BizTech & Economy": biztechAndEconomy,
  "China & Asia unpacked": chinaAndAsiaUnpacked,
  Essential: essential,
  "Everything Hong Kong": everythingInHongKong,
  Lifestyle: lifestyle,
  "Pictures, Films & Video": picturesFilmsAndVideo,
  Sport: sport,
} as const;

export const ThumbnailDisplay: React.FunctionComponent = () => {
  const { packageDisplayName = "", packageKey } = useNewsletterContext();

  if (!notEmpty(packageKey)) return null;

  return (
    <ThumbnailContainer>
      <img alt={packageDisplayName} src={thumbnailMap[packageKey]?.src} />
    </ThumbnailContainer>
  );
};

ThumbnailDisplay.displayName = "ThumbnailDisplay";
